import routes from '@/modules/stores/stores-routes';
import store from '@/modules/stores/stores-store';

export default {
  routes,
  store,
};
